import axios, { AxiosResponse } from "axios"

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const API_V1_URL = `${API_BASE_URL}/v1`;

export function fetchHealthCheck(token: string, tenantId: number, cloud?: string, region?: string): Promise<AxiosResponse> {
    const params = new URLSearchParams({
        tenantId: tenantId.toString()
    });
    if (cloud) params.append('cloud', cloud);
    if (region) params.append('region', region);
    
    return axios.get(
        `${API_V1_URL}/ctxr/-1/healthcheck?${params.toString()}`,
        { headers: { Authorization: `Bearer ${token}` } }
    )
}

export type HealthCheckSeries = "cpu" | "ram" | "storage";

export interface HealthCheckHistoryParams {
    tenantId: number;
    limit: number;
    startDate: Date;
    endDate: Date;
    only?: HealthCheckSeries;
}

export interface CpuHistoryRecord {
    createdAt: string;
    cpu: number;
}

export interface MemoryUsage {
    percent: number;
    used: number;
    free: number;
    total: number;
}

/** `only=<series>` answers each row with `createdAt` and that series' own column. */
export type MemoryHistoryRecord =
    | { createdAt: string; ram: MemoryUsage }
    | { createdAt: string; storage: MemoryUsage };

export interface ProcessSnapshot {
    cpu_percent: number;
    memory_percent: number;
    execution_times?: string;
}

export interface FullHistoryRecord {
    createdAt: string;
    processStatus: Record<string, ProcessSnapshot | string> | null;
    ports: Record<string, { status: string }> | null;
}

export interface HealthCheckHistoryResponse<T> {
    data: T[];
}

export function fetchHealthCheckHistory<T>(
    token: string,
    instanceId: string,
    { tenantId, limit, startDate, endDate, only }: HealthCheckHistoryParams
): Promise<AxiosResponse<HealthCheckHistoryResponse<T>>> {
    const params = new URLSearchParams({
        tenantId: tenantId.toString(),
        limit: limit.toString(),
        start_date: startDate.toISOString(),
        end_date: endDate.toISOString(),
    });
    if (only) params.append("only", only);

    return axios.get<HealthCheckHistoryResponse<T>>(
        `${API_V1_URL}/ctxr/-1/healthcheck/${instanceId}?${params.toString()}`,
        { headers: { Authorization: `Bearer ${token}` } }
    );
}
